var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 15.749,
    viewBox: "0 0 24 15.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167907",
    "data-name": "Group 167907",
    transform: "translate(0 -98.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51368",
    "data-name": "Path 51368",
    d: "M12,98.725c-4.585,0-8.744,2.762-11.812,7.247a1.131,1.131,0,0,0,0,1.248c3.068,4.491,7.227,7.253,11.812,7.253s8.744-2.762,11.812-7.247a1.131,1.131,0,0,0,0-1.248c-3.068-4.491-7.227-7.253-11.812-7.253Zm.329,13.419c-3.044.211-5.558-2.551-5.366-5.907a5.334,5.334,0,0,1,4.708-5.183c3.044-.211,5.558,2.551,5.366,5.907A5.351,5.351,0,0,1,12.329,112.144Zm-.152-2.562a3,3,0,0,1-.349-5.972,3,3,0,0,1,.349,5.972Z",
    fill: "#5460d1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.aee21c3b2ebb0094205e4cec1ad0291b.svg";
export { ForwardRef as ReactComponent };